'use strict';
module.exports = function(app) {
    require('./js/controller/slide_show.controller.js')(app);
    require('./scss/slide_show.scss');
};



/*****************
 ** WEBPACK FOOTER
 ** ./slide_show/index.js
 ** module id = 60
 ** module chunks = 0
 **/